// Pribin K Benny — Resume Data
export const profile = {
  name: "Pribin K Benny",
  title: "Robotics Software Engineer",
  location: "London, UK",
  email: "pribinbenny471@gmail.com",
  phone: "+44 7587 583788",
  linkedin: "https://www.linkedin.com/in/pribinkbenny/",
  github: "https://github.com/PRIBINKBENNY?tab=repositories",
  resume: "/docs/pribin-benny-resume.pdf",
  tagline:
    "Building intelligent machines that see, decide, and move — ROS2, computer vision, and autonomous systems.",
  summary:
    "Innovative robotics engineer designing, developing, and deploying intelligent robotic systems using ROS2, Python, OpenCV, YOLOv8, Gazebo and Unity. Strong background in autonomous navigation, obstacle avoidance, sensor fusion, robot localisation and human–robot interaction.",
};

export const skills = {
  core: [
    { label: "ROS / ROS 2", tag: "framework" },
    { label: "Python", tag: "language" },
    { label: "C++", tag: "language" },
    { label: "YOLOv8", tag: "vision" },
    { label: "OpenCV", tag: "vision" },
    { label: "PyTorch", tag: "ml" },
    { label: "TensorFlow", tag: "ml" },
    { label: "SLAM", tag: "robotics" },
    { label: "MoveIt", tag: "robotics" },
    { label: "Gazebo", tag: "sim" },
    { label: "Unity", tag: "sim" },
    { label: "Docker", tag: "platform" },
    { label: "Linux / Ubuntu", tag: "platform" },
    { label: "Git", tag: "platform" },
    { label: "MATLAB", tag: "language" },
    { label: "SQL", tag: "language" },
    { label: "AWS AI", tag: "platform" },
    { label: "Generative AI", tag: "ml" },
    { label: "Reinforcement Learning", tag: "ml" },
    { label: "Sensor Fusion", tag: "robotics" },
  ],
  domains: [
    "Robotics Software Development",
    "Autonomous Navigation Systems",
    "Hardware–Software Integration",
    "Obstacle Detection & Avoidance",
    "Path Planning Algorithms",
    "Human–Robot Interaction",
    "Machine Learning Applications",
    "Research-Led Innovation",
  ],
};

export const experience = [
  {
    id: "greggs",
    role: "Shift Manager",
    org: "Greggs",
    location: "London, UK",
    period: "Jan 2026 — Present",
    bullets: [
      "Direct end-to-end inventory analytics, logistics coordination and waste-control initiatives.",
      "Led a team of 10+ staff in a high-pressure environment — surpassed KPIs by 20%.",
      "Optimised inventory tracking and logistics for daily operations and improved stock accuracy.",
    ],
    tags: ["Leadership", "Operations", "Data-driven"],
  },
  {
    id: "kjc",
    role: "Robotics Engineer — Intern",
    org: "Kristu Jayanti College",
    location: "India",
    period: "Mar 2023 — Jun 2023",
    bullets: [
      "Built a Voice-TTS chatbot interface for real-time student & staff interaction.",
      "Deployed end-to-end ROS2 stack on Nvidia Jetson Nano with RpLidar, GPS and temp sensors.",
      "Implemented ROS2 navigation + OpenCV 3D mapping for localisation and obstacle avoidance.",
    ],
    tags: ["ROS2", "Jetson Nano", "LiDAR", "OpenCV"],
  },
  {
    id: "orbitx",
    role: "Scientific Researcher — Intern",
    org: "ORBITX India Aerospace",
    location: "India",
    period: "Oct 2022 — May 2023",
    bullets: [
      "Collaborated on Guidance, Navigation & Control (GNC) systems for flight stability.",
      "Formulated reentry protocols & mathematical models for Project Atal Yaan RLV.",
      "Improved system reliability by up to 21% using Power BI, AutoCAD, Maya, Blender.",
    ],
    tags: ["GNC", "Aerospace", "Modelling"],
  },
  {
    id: "mukkudal",
    role: "Robotics Engineer — Intern",
    org: "Mukkudal Robotics",
    location: "India",
    period: "Mar 2022 — Apr 2022",
    bullets: [
      "Built a spot-micro robot for COVID-19 frontline healthcare assistance.",
      "Integrated GPS, temperature sensors and Voice-TTS chatbot on a ROS2 architecture.",
      "Executed industrial-grade simulations validating robot–human interaction protocols.",
    ],
    tags: ["ROS2", "Healthcare", "Simulation"],
  },
];

export const education = [
  {
    degree: "MSc, Artificial Intelligence & Robotics",
    school: "University of Hertfordshire",
    period: "2024 — 2025",
    note: "Machine Learning, Neural Networks, Robotics Research, Autonomous Systems. Young Indian Achiever 2025 distinction.",
  },
  {
    degree: "Master of Computer Applications (MCA)",
    school: "Kristu Jayanti College, India",
    period: "2021 — 2023",
    note: "Computer science, intelligent systems & applied software engineering.",
  },
  {
    degree: "Bachelor of Computer Applications (BCA)",
    school: "Kristu Jayanti College, India",
    period: "2018 — 2021",
    note: "Programming fundamentals, data structures and systems design.",
  },
];

export const projects = [
  {
    id: "ai-robot",
    name: "AI-Enabled Autonomous Robot",
    role: "Lead Developer",
    summary:
      "YOLOv8-based navigation stack on ROS improving obstacle detection & avoidance efficiency by 20%. Validated sensor-fusion in Gazebo & Unity before hardware deployment.",
    stack: ["ROS2", "YOLOv8", "Python", "Gazebo", "Unity"],
  },
  {
    id: "atal-yaan",
    name: "Project Atal Yaan — Reusable Launch Vehicle",
    role: "Scientific Researcher",
    summary:
      "Supported development of GNC systems & reentry protocols. Refined flight trajectories via advanced mathematical modelling; reinforced aerodynamic efficiency and resilience.",
    stack: ["GNC", "Blender", "Maya", "AutoCAD", "Power BI"],
  },
];

export const certifications = [
  "Launching into Machine Learning — Google / Coursera",
  "Introduction to Generative AI — Google",
  "Technical Support Fundamentals — Google",
];
